export default __webpack_public_path__ + "static/media/faq_flower_1.e102f60b.png";